import { Cwb_PositionalAttribute } from "../../../../Shared/Shared.js";
import { ofArray } from "../../../../fable_modules/fable-library.3.7.9/List.js";

export const lemma = new Cwb_PositionalAttribute("lemma", "Lemma");

export const pos = new Cwb_PositionalAttribute("pos", "Ordklasse");

export const type = new Cwb_PositionalAttribute("type", "Type");

export const grad = new Cwb_PositionalAttribute("grad", "Grad");

export const tempus_modus = new Cwb_PositionalAttribute("tempus_modus", "Tempus eller modus");

export const kasus = new Cwb_PositionalAttribute("kasus", "Kasus");

export const person = new Cwb_PositionalAttribute("person", "Person");

export const tall = new Cwb_PositionalAttribute("tall", "Tal");

export const kjonn = new Cwb_PositionalAttribute("kjonn", "KjÃ¸nn");

export const diatese = new Cwb_PositionalAttribute("diatese", "Diatese");

export const bestemthet = new Cwb_PositionalAttribute("bestemthet", "Bunden/ubunden form");

export const niv = new Cwb_PositionalAttribute("niv", "Syntaktisk nivÃ¥");

export const fun = new Cwb_PositionalAttribute("fun", "Syntaktisk funksjon");

export const ind = new Cwb_PositionalAttribute("ind", "Indeks");

export const dep = new Cwb_PositionalAttribute("dep", "Dependent");

export const list = ofArray([lemma, pos, type, grad, tempus_modus, kasus, person, tall, kjonn, diatese, bestemthet, niv, fun, ind, dep]);

